import { WebPageEvents } from '@griply/types';
import React, { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useTrackPageVisitEvent } from 'shared/hooks/use-track-page-visit-event';
import { QueryParamOptions, useQueryParam } from 'shared/lib/react-router-dom';

import { EmptyCategoryList } from './components/empty-category-list';
import { LoadingOverview, Overview } from './components/overview';
import { PageTopBar } from './components/page-top-bar';
import {
  LoadingSearchOverview,
  SearchOverview,
} from './components/search-overview';
import * as Styled from './goals-templates-overview.style';

export const GoalTemplatesOverview: React.FC = () => {
  useTrackPageVisitEvent(WebPageEvents.GoalTemplatesOverview, undefined);
  const [searchText, setSearchText] = useQueryParam(QueryParamOptions.Search);

  return (
    <Styled.Container>
      <Styled.Main>
        <Styled.MainContent>
          <PageTopBar
            initialSearch={searchText ?? ''}
            onSearch={setSearchText}
          />

          <Styled.Content>
            {searchText ? (
              <Suspense fallback={<LoadingSearchOverview />}>
                <SearchOverview searchText={searchText} />
              </Suspense>
            ) : (
              <ErrorBoundary fallback={<EmptyCategoryList />}>
                <Suspense fallback={<LoadingOverview />}>
                  <Overview />
                </Suspense>
              </ErrorBoundary>
            )}
          </Styled.Content>
        </Styled.MainContent>
      </Styled.Main>
    </Styled.Container>
  );
};
